import { ItdsMode } from '@reliance/types/enums/ItdsMode';
import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Billing from './Billing';
import Calling from './Calling';
import Features from './Features';
import GeneralDetails from './GeneralDetails';
import Rates from './Rates';
import SystemStatuses from './SystemStatuses';
import Taxes from './Taxes';
import TrustAccounts from './TrustAccounts';

type FacilityDetailsTabProps = {
  facility: Facility;
};

const FacilityDetailsTab: React.FC<FacilityDetailsTabProps> = ({ facility }) => {
  return (
    <Card>
      <Card.Body>
        <Row>
          <Col md={3}>
            <GeneralDetails facility={facility} />

            <div className="mt-2">
              <Billing facility={facility} />
            </div>

            <div className="mt-2">
              <Rates facility={facility} />
            </div>
          </Col>

          <Col md={3}>
            {facility.dialingInstructions && <Calling facility={facility} />}

            <div className="mt-2">
              <Taxes facility={facility} />
            </div>

            {facility.itdsMode != ItdsMode.DISABLED && (
              <div className="mt-2">
                <TrustAccounts facility={facility} />
              </div>
            )}
          </Col>

          <Col md={3}>
            <Features facility={facility} />
          </Col>

          <Col md={3}>
            <SystemStatuses facility={facility} />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default FacilityDetailsTab;
